import React, { ReactElement } from 'react';
import { Typography } from 'antd';
import { InfoItemStyled } from './Card.styles';

const { Text } = Typography;

type Props = {
  label: string;
  value: string;
  title?: string;
  ellipsis?: boolean;
};

export const CardInformation = ({
  label,
  value,
  title = '',
  ellipsis = false,
}: Props): ReactElement => {
  return (
    <InfoItemStyled>
      <span>{label}</span>
      <Text title={title} strong ellipsis={ellipsis}>
        {value}
      </Text>
    </InfoItemStyled>
  );
};
